<template>
  <div class="team-creation">
    <form class="team-creation__form" @submit.prevent="submit">
      <div class="team-creation__content">
        <div class="team-creation__row row">
          <div class="col-12 col-md-6">
            <AppControl
              label="Название команды"
              class="team-creation__control"
              :error="getError('name')"
            >
              <AppInput
                v-model="$v.form.name.$model"
                class="team-creation__input"
                :invalid="isInvalid('name')"
                placeholder="Введите название"
                theme="third"
                @input="clearError('name')"
              />
            </AppControl>

            <AppControl
              v-if="cities"
              label="Выберите город"
              class="team-creation__control"
              :error="getError('city_id')"
            >
              <AppSelect
                :options="cities"
                value-key="id"
                label-key="name"
                v-model="$v.form.city_id.$model"
                class="team-creation__input"
                :invalid="isInvalid('city_id')"
                placeholder="Выберите город"
                theme="third"
              />
            </AppControl>
          </div>
          <div class="col-12 col-md-6">
            <AppControl label="Логотип">
              <ImageUpload
                #default="{ imageSrc, chooseImage }"
                @change="$v.form.file.$model = $event"
                @error="handleLogoError"
              >
                <div class="team-creation__logo-container">
                  <TeamLogo :src="imageSrc" :color="logoColor" />
                  <AppBtn class="team-creation__logo-btn" @click="chooseImage">
                    Выбрать
                  </AppBtn>
                </div>
              </ImageUpload>
            </AppControl>
          </div>
        </div>
      </div>

      <ModalMessage>{{ message }}</ModalMessage>

      <AppBtn
        type="submit"
        class="team-creation__submit"
        color="third"
        :loading="loading"
      >
        Создать команду
      </AppBtn>
    </form>
  </div>
</template>

<script>
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import { required } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/core/common/";
import { asyncModal } from "@/components/ui/modal/";
import TeamLogo from "@/components/teams/TeamLogo";
import ImageUpload from "@/components/ui/ImageUpload";
import service from "@/services/team";
import { mapActions, mapState } from "vuex";
import { ModalMessage } from "@/components/ui/modal/";

const defaultForm = () => ({
  name: "",
  city_id: null,
  file: null
});

const TeamCreation = {
  name: "TeamCreation",

  components: {
    AppControl,
    TeamLogo,
    ImageUpload,
    ModalMessage
  },

  data: () => ({
    form: defaultForm(),
    formErrors: {},
    loading: false,
    message: ""
  }),

  computed: {
    ...mapState("dictionaries", {
      cities: ({ dictionaries }) => dictionaries.cities
    }),
    logoColor() {
      return this.isInvalid("file") ? "invalid" : "second";
    }
  },

  validations: {
    form: {
      name: { required },
      city_id: { required },
      file: {}
    }
  },

  created() {
    if (!this.cities) {
      this.getDictionary("cities");
    }
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"]),
    ...mapActions("auth", ["refreshProfile"]),
    ...mapActions("team", ["fetchTeam"]),

    clearError(field) {
      delete this.formErrors[field];
    },

    getError(field) {
      return (
        getValidationMessage(this.$v.form[field]) ||
        (this.formErrors[field] && this.formErrors[field][0])
      );
    },

    isInvalid(field) {
      return this.$v.form[field].$error || !!this.formErrors[field];
    },

    handleLogoError(error) {
      showAlert(error);
    },

    async submit() {
      if (this.loading) return;
      this.formErrors = {};
      this.message = "";
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, data, message } = await service.createTeam(this.form);

        if (success) {
          this.$modals.close(this);
          this.fetchTeam();
          this.refreshProfile();
          showAlert(
            "Ваша заявка принята. В ближайшее время наш менеджер свяжется с Вами для подтверждения участия команды."
          );
        } else {
          this.formErrors = data || {};
          this.message = message || "Не удалось создать команду.";
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default TeamCreation;

export function openModal() {
  return asyncModal({
    name: "team-creation-modal",
    component: TeamCreation,
    title: "Регистрация команды",
    dismissable: false
  });
}
</script>

<style lang="scss">
.team-creation {
  width: 665px;
  max-width: 100%;
  margin: 0 auto;

  &__content {
    max-width: 100%;
    margin: 0 auto 5px;
  }

  &__control {
    margin-bottom: 30px;
  }

  &__input {
    height: 50px;
    border-radius: 4px;
    font-weight: fw(bold);
    font-size: 20px;
    text-transform: uppercase;
  }

  &__submit {
    width: 270px;
    height: 50px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 16px;
  }

  &__logo-container {
    display: flex;

    .team-logo {
      width: 167px;
      height: 167px;
    }
  }

  &__logo-btn {
    height: 50px;
    width: 143px;
    font-size: 16px;
    text-transform: uppercase;
    margin-left: 5px;
  }

  @include breakpoint("xs-only") {
    &__logo-container {
      flex-direction: column;
    }
    &__logo-btn {
      margin-left: 0;
      margin-top: 5px;
      width: 100%;
    }
  }
}
</style>
